import React from "react";
import { useTranslation } from "react-i18next";

function AddProductsHeader({ title, hasDes, isCustomProduct, setIsCustomProduct, productSide = false ,isEdit=false}) {
  const { t } = useTranslation("addProductsHeader");

  const { i18n } = useTranslation("addProductsHeader");
  const isRTL = i18n.dir() === 'rtl';

  return (
    <div className="flex flex-col gap-2 mb-2">
      <div className="flex justify-between items-center">
      <h1 className="text-[24px] font-[900] text-text-dark tracking-[-0.5px] flex items-center gap-3">
        {title}
        {/* if edit and custom */}
        {isEdit  && (
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-purple-100 text-purple-700 text-sm font-medium border border-purple-200">
            {isCustomProduct ? t("addProductsHeader.editingCustomProduct") : t("addProductsHeader.standardProduct")}
          </span>
        )}
      </h1>
      {productSide && (
        <div className="flex">
          <button
            className={`px-4 py-2 ${isRTL ? 'rounded-r-md' : 'rounded-l-md'} border border-[#6609F8]  ${
          isCustomProduct ? "bg-[#5507CF] text-white" : "text-[#6609F8]"
            }`}
            onClick={() => setIsCustomProduct(true)}
          >
            {t("addProductsHeader.customProduct")}
          </button>
          <button
            className={`px-4 py-2 ${isRTL ? 'rounded-l-md' : 'rounded-r-md'} border-t border-r border-b border-[#6609F8] ${
          !isCustomProduct ? "bg-[#5507CF] text-white" : "text-[#6609F8]"
            }`}
            onClick={() => setIsCustomProduct(false)}
          >

            {t("addProductsHeader.standardProduct")}
          </button>
        </div>
        )}
        </div>
      
        {hasDes && (
          <p className="text-[16px] font-normal text-text-medium">
            {t("addProductsHeader.description")}
            {isCustomProduct ? (
          <span>{t("addProductsHeader.customProductDescription")}</span>
            ) : (
          <span>{t("addProductsHeader.standardProductDescription")}</span>
            )}
            {/* Add a product with fixed details and pricing */}
          {/* Add a product can customize and clients can request quote for */}
        </p>
      )}
    </div>
  );
}

export default AddProductsHeader;
